'use strict';

class AudioConferenceService {
    constructor() {

    }

    endConference() {
        wv.sendTextMessage(text_stopAudioConference + text_seperator);
    }

    endCall() {
        wv.sendTextMessage(text_endCall + text_seperator);
    }

    initCall() {
        wv.sendTextMessage(text_initAudioConference);
    }

    acceptCall(value) {
        wv.sendTextMessage(text_acceptCall + text_seperator + (value ? 1 : 0));
    }

    muteAllMicrophone() {
        wv.sendTextMessage(text_muteAllMicrophone);
    }
}

export default AudioConferenceService;